import { Api } from '@/api';
import { STRIPE_API_KEY } from '@/config/settings';

let stripePromiseInstance = null;
export const stripePromise = async () => {
  //Returns a memoised Stripe instance
  if (stripePromiseInstance) {
    return stripePromiseInstance;
  }
  try {
    const stripe = await import('@stripe/stripe-js/pure');
    stripePromiseInstance = await stripe.loadStripe(STRIPE_API_KEY);
    return stripePromiseInstance;
  } catch (error) {
    console.error('Failed to initialize Stripe:', error);
    throw new Error(
      'Failed to initialize payment system. Please try again later.'
    );
  }
};

export const navigateToStripeBillingPortal = async userId => {
  const currentUrl = window.location.href;
  const { sessionUrl } = await Api.getStripeBillingPortalUrl(
    userId,
    currentUrl
  );
  window.location.assign(sessionUrl);
};

export const navigateToStripeCheckout = async ({
  successUrl,
  cancelUrl = window.location.href,
  priceId = undefined,
  checkoutMode = 'subscription',
  settings = undefined,
  referral = undefined
}) => {
  const { sessionId } = await Api.createStripeCheckoutSession({
    priceId,
    successUrl,
    cancelUrl,
    mode: checkoutMode,
    settings,
    referral
  });

  const stripe = await stripePromise();
  const { error } = await stripe.redirectToCheckout({ sessionId });

  if (error) {
    throw error;
  }
};
